
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }  
  
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var quote = {
      title: 'Quote',
      url:'https://www.multishop.lu/en/pages/request-for-quote',
      target:1,
      badge: null,
      icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)" /></svg>',
      isShow: 1,
      loader:null,
      body_html: null
    }
    settings.navs.splice(8, 0, quote);
    
    var bidding = {
      title: 'Bidding',
      url:'https://www.multishop.lu/pages/bidding-details',
      target:1,
      badge: null,
      icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)" /></svg>',
      isShow: 1,
      loader:null,
      body_html: null
    }
    settings.navs.splice(9, 0, bidding);
    
     var subscription = {
      title: 'Subscription',
      url:'/a/auto-subproxy/subscriptionList/'+ window.flits_route_customer_id,
      target:1,
      badge: null,
      icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)" /></svg>',
      isShow: 1,
      loader:null,
      body_html: null
    }
    settings.navs.splice(10, 0, subscription);
    
  });
  
  
  function addToCartCustom(params){
    flitsSnackbar.show({ text: Flits.t("Flits.locals.cart_page.adding_items_to_cart", "Adding items to cart..."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default flits-alert-custom", duration: !1 }),
      Flits.ajax({ type: "POST", url: "/cart/add.js", data: params, dataType: "json" })
    .done(function (resp) {
      console.log(resp);
      Flits.setLocalStorage("openCart", "true");
      setTimeout(function(){
        Flits.flitsSnackbarHide();
        Shopify.getCart(function(cart) {
            Shopify.updateCartInfo(cart, '#cart-info #cart-content'); 
        });
      },2000);
      
     setTimeout(function(){ 
     	Flits('.cart-toggle')[0].click();
     },2500);
      
    })
    .fail(function (resp) {
      flitsSnackbar.show({ text: resp.responseJSON.description, pos: "bottom-center", showAction: !1, customClass: "flits-alert-error" });
    })
    .always(function () {});
  }
  
   Flits(document).on("click", ".flits-reorder-btn", function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    let items = flitsOrder[Flits(this).attr("data-flits-target")];
    let params = {};
    let noItem = 0;
    let soldOutItem = 0;
    if (((params.items = []), items.length > 0)) {
      for (let i = 0; items.length > i; i++) {
        let item = items[i];
        item.item_variant_id
        ? item.available == "true"
        ? (parseInt(item.inventory_quantity) <= parseInt(item.quantity)
           ? cartOrder[item.variant_id] &&
           (parseInt(item.inventory_quantity) > parseInt(cartOrder[item.variant_id].cart_quantity)
            ? (item.quantity = parseInt(item.inventory_quantity) - parseInt(cartOrder[item.variant_id].cart_quantity))
            : (item.quantity = parseInt(item.inventory_quantity)),
            flitsSnackbar.show({
          text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."),
          pos: "bottom-center",
          showAction: !1,
          customClass: "flits-alert-default",
        }))
           : cartOrder[item.variant_id] &&
           parseInt(item.inventory_quantity) <= parseInt(cartOrder[item.variant_id].cart_quantity) + parseInt(item.quantity) &&
           ((item.quantity = parseInt(item.inventory_quantity) - parseInt(cartOrder[item.variant_id].cart_quantity)),
            flitsSnackbar.show({
          text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."),
          pos: "bottom-center",
          showAction: !1,
          customClass: "flits-alert-default",
        })),
           params.items.push({ id: item.variant_id, quantity: item.quantity }))
        : soldOutItem++
        : noItem++;
      }
      noItem == 1
      ? flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.one_product_unavailable", "One of the products is unavailable"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" })
      : noItem > 1 &&
        flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.some_products_unavailable", "Some of the products are unavailable"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" }),
        soldOutItem == 1
      ? setTimeout(
        function () {
          flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.one_product_sold_out", "One of the products is sold out."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" });
        },
        noItem > 0 ? 1500 : 0
      )
      : soldOutItem > 1 &&
        setTimeout(
        function () {
          flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.some_products_sold_out", "Some of the products are sold out"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" });
        },
        noItem > 0 ? 1500 : 0
      ),
        Flits.dispatchEvent("Flits:order:BeforeReOrder", { params: params }),
        setTimeout(
        function () {
          addToCartCustom(params);
        },
        soldOutItem > 0 || noItem > 0 ? 2500 : 1000
      );
    }
  });
  
}(Flits));
